import { types } from 'mobx-state-tree';
var AzureStorageEntryKind = types.enumeration(['prefix', 'blob']);
export default AzureStorageEntryKind;
//# sourceMappingURL=AzureStorageEntryKind.js.map